import { render } from "./AboutOverview.vue?vue&type=template&id=5fbe898b&scoped=true&ts=true"
import script from "./AboutOverview.vue?vue&type=script&lang=ts"
export * from "./AboutOverview.vue?vue&type=script&lang=ts"

import "./AboutOverview.vue?vue&type=style&index=0&id=5fbe898b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbe898b"]])

export default __exports__